<template>
  <div class="bg-primarybg min-h-screen">
    <Loader id="loader" class="hidden" />
    <HeaderComponent />
    <main id="main-content" aria-label="Enrollment form">
      <router-view />
    </main>
    <FooterComponent />
  </div>
</template>

<script>
import Loader from "./components/Loader.vue";
import HeaderComponent from "./components/HeaderComponent.vue";
import FooterComponent from "./components/FooterComponent.vue";
export default {
  name: "MemberEnrollmentForm",
  components: {
    HeaderComponent,
    FooterComponent,
    Loader
    }
};
</script>

<style scoped>
/* Add component-specific styles here if needed */
</style>
